import { RouterInterface } from '@/routers/router-interface';
import { NylasSchedulerConfigStoreType } from '../../stores/scheduler-config-store';
import { NylasSchedulerStoreType } from '../../stores/scheduler-store';
import { debug } from '@/utils/utils';
import { NylasConnectorInterface } from '../connector-interface';
import { NylaSchedulerAPIConnector } from '../shared/api/scheduler';
/**
 * Base class for the Nylas connector.
 */
export class NylasConnector implements NylasConnectorInterface {
  public router: RouterInterface;
  public nylasSchedulerStore: NylasSchedulerStoreType;
  public nylasSchedulerConfigStore: NylasSchedulerConfigStoreType;
  public schedulerAPIURL: string;

  private _schedulerAPIConnector: NylaSchedulerAPIConnector | undefined;

  constructor(
    router: RouterInterface,
    nylasSchedulerStore: NylasSchedulerStoreType,
    nylasSchedulerConfigStore: NylasSchedulerConfigStoreType,
    schedulerAPIURL: string = 'https://api.us.nylas.com',
  ) {
    this.router = router;
    this.schedulerAPIURL = schedulerAPIURL;
    this.nylasSchedulerStore = nylasSchedulerStore;
    this.nylasSchedulerConfigStore = nylasSchedulerConfigStore;
  }

  public init() {
    debug('NylasConnector init');
  }

  public get schedulerStore() {
    return this.nylasSchedulerStore;
  }

  public get schedulerConfigStore() {
    return this.nylasSchedulerConfigStore;
  }

  public resetStores() {
    this.nylasSchedulerStore.reset();
    this.nylasSchedulerConfigStore.reset();
  }

  public get scheduler() {
    if (this._schedulerAPIConnector) {
      return this._schedulerAPIConnector;
    }
    this._schedulerAPIConnector = new NylaSchedulerAPIConnector({
      schedulerAPIURL: this.schedulerAPIURL,
      schedulerStore: this.schedulerStore,
    });
    return this._schedulerAPIConnector;
  }
}

export type PublicMethods<T> = {
  [K in keyof T]: T[K] extends Function ? (string extends K ? never : K) : never;
}[keyof T];

export type NylasConnectorPublicMethods = PublicMethods<NylasConnector>;
